<div
  class="grid gap-3"
  [ngClass]="{
    'grid-cols-1': colummMax === 1,
    'md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2': colummMax === 2,
    'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3': colummMax === 3,
    'md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4': colummMax === 4,
  }"
>
  @for (input of formHydrid; track input.key) {
    @if (input.type === 'input-general-currency') {
      <app-input-general
        [ngClass]="{
          'col-span-full': input.colFull,
        }"
        [formControlGeneral]="input.control"
        [mask]="'separator.0'"
        [prefix]="'$'"
        [thousandSeparator]="','"
        [allowNegativeNumbers]="true"
        [label]="input.label"
        [placeholder]="input.placeholder"
      ></app-input-general>
    }
    @if (input.type === 'input-general-number') {
      <app-input-general
        [ngClass]="{
          'col-span-full': input.colFull,
        }"
        [formControlGeneral]="input.control"
        [mask]="'separator'"
        [label]="input.label"
        [placeholder]="input.placeholder"
      ></app-input-general>
    }
    @if (input.type === 'input-general') {
      <app-input-general
        [ngClass]="{
          'col-span-full': input.colFull,
        }"
        [formControlGeneral]="input.control"
        [label]="input.label"
        [placeholder]="input.placeholder"
      ></app-input-general>
    }
    @if (input.type === 'input-general-select') {
      <app-input-general-select
        [ngClass]="{
          'col-span-full': input.colFull,
        }"
        [formControlGeneral]="input.control"
        [label]="input.label"
        [placeholder]="input.placeholder"
        [arrayData]="input.array"
        [inputSelect]="input.selectedValue || { value: '', description: '' }"
      ></app-input-general-select>
    }
    @if (input.type === 'input-general-calendar') {
      <app-input-general-calendar
        [ngClass]="{
          'col-span-full': input.colFull,
        }"
        [formControlGeneral]="input.control"
        [label]="input.label"
        [placeholder]="input.placeholder"
      ></app-input-general-calendar>
    }
    @if (input.type === 'input-general-checkbox') {
      <div class="h-18.25 flex items-center pb-5.5">
        <mat-checkbox [formControl]="input.control">{{ input.label }}</mat-checkbox>
      </div>
    }
    @if (input.type === 'input-general-text-area') {
      <app-input-general-text
        [formControlGeneral]="input.control"
        [label]="input.label"
        [placeholder]="input.label"
      ></app-input-general-text>
    }
  }
</div>
